<div style="display: inline-block" [tooltip]="'PUZZLE.move_info' | translate" placement="bottom">
  <ion-text color="primary" class="move-counter">
    <div class="info">{{'PUZZLE.move' | translate}}</div>
    <div class="info-value">{{ this.moveCounter }}</div>
  </ion-text>
</div>
